import { CarouselPageSizeConfig } from "@expressable/syntax-ds";

export const PageSizeConfig: CarouselPageSizeConfig = {
    default: 8,
    tablet: 7,
    mobile: 5,
    'mobile-sm': 3,
    'mobile-xs': 3,
  };